// pitstopResultsBus — die "Voraus"-Treffer auf der Karte zeigen.
//
// Der Pit-Stop-Finder (PitstopPanel) sucht POIs voraus und publisht die Top-
// Treffer hier rein. MapPage subscribed, zeichnet sie als Marker mit Entfernung
// + Umweg und zoomt drauf. Tap auf einen Marker → Route dorthin. So sieht man
// die Optionen im Kartenkontext statt nur als Liste.

export interface PitstopResultItem {
  id: string;
  lat: number;
  lon: number;
  name: string;
  /** POI-Kategorie (für Emoji/Anzeige). */
  category: string;
  /** Luftlinie Standort→POI in Metern. */
  distM: number;
  /** Echter Umweg (hin+zurück, Straße) in km — null wenn nicht berechenbar
   *  (z.B. kein aktiver Ride/Route oder offline). */
  detourKm: number | null;
  /** Zusätzliche Höhenmeter (hin+zurück) in m — null wenn nicht berechenbar. */
  detourHm: number | null;
  /** [lon,lat] optimaler Ausstieg/Wiedereinstieg (fürs Routing), wenn berechnet. */
  exit?: [number, number] | null;
  rejoin?: [number, number] | null;
}

export interface PitstopResults {
  origin: { lat: number; lon: number };
  items: PitstopResultItem[];
}

type Listener = (r: PitstopResults | null) => void;

class PitstopResultsBus {
  private current: PitstopResults | null = null;
  private readonly listeners = new Set<Listener>();

  get(): PitstopResults | null {
    return this.current;
  }
  publish(r: PitstopResults | null): void {
    this.current = r;
    for (const l of this.listeners) l(r);
  }
  clear(): void {
    this.publish(null);
  }
  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const pitstopResultsBus = new PitstopResultsBus();
